import { environment } from "../../../environments/environment";

// in milliseconds
export const MAX_EXPORT_DURATION: number = environment.production ? 300 * 1000 : 300 * 1000;
export const MAX_EXPORT_PARALLELISM: number = environment.production ? 5 : 2;
